import { CanMatchFn } from '@angular/router';

const BLOCKED_DAYS = [1, 10, 20];
const BLOCKED_UNTIL_HOUR = 4;
const TIMEZONE = 'Europe/Bucharest';

export function isEarlyRepaymentBlockedDay(date = new Date()): boolean {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: TIMEZONE,
        day: 'numeric',
        hour: 'numeric',
        hourCycle: 'h23'
    }).formatToParts(date);

    const dayOfMonth = Number(parts.find(part => part.type === 'day')?.value);
    const hour = Number(parts.find(part => part.type === 'hour')?.value);

    if (BLOCKED_DAYS.includes(dayOfMonth)) {
        return true;
    }

    const previousDay = dayOfMonth - 1;
    return BLOCKED_DAYS.includes(previousDay) && hour < BLOCKED_UNTIL_HOUR;
}

export const earlyRepaymentAvailableGuard: CanMatchFn = () => {
    return !isEarlyRepaymentBlockedDay();
};
